import { useState, useEffect } from "react";
import { useDispatch , useSelector} from "react-redux";
import { addJob, fetchJobs, updateJob } from "../features/jobs/jobSlice";
import { useParams ,  useNavigate } from "react-router-dom";

export default function AddJob() {
  const isEditMode = window.location.pathname.includes("edit-job");
  const { jobs } = useSelector((state) => state.job);
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // useEffect(() => {
  //   dispatch(fetchJobs());
  // }, []);
  useEffect(() => {
    if (jobs.length === 0) {
      dispatch(fetchJobs());
    }
  }, [dispatch, jobs.length]); // eger jobs.length degisir ise tekrar fetch et

  const editJob = jobs.find((job) => String(job.id) === id); // find job to edit

  useEffect(() => {
    // when isEditMode call select jobs
    if (isEditMode && editJob) {
      setFormData({
        company: editJob.company,
        position: editJob.position,
        location: editJob.location,
        status: editJob.status,
        jobType: editJob.jobType,
      });
    }
  }, [isEditMode, editJob]);

  const [formData, setFormData] = useState({
    company: "",
    position: "",
    location: "",
    status: "pending",
    jobType: "full-time",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.company || !formData.position) return;

    if (isEditMode) {
      dispatch(
        updateJob({
          id,
          updatedJob: {
            ...formData,
            id,
          },
        })
      );
    } else {
      dispatch(
        addJob({
          ...formData,
          id: Date.now().toString(),
          createDate: new Date().toISOString(),
        })
      );
    }

    navigate("/all-jobs");
  };

  return (
    <div>
      {isEditMode ? (
        <h2 className="mb-4">Edit Job</h2>
      ) : (
        <h2 className="mb-4">Add New Job</h2>
      )}
      <div className="card p-4">
        <form onSubmit={handleSubmit}>
          <input
            name="company"
            value={formData.company}
            onChange={handleChange}
            className="form-control mb-3"
            placeholder="Company Name"
          />

          <input
            name="position"
            value={formData.position}
            onChange={handleChange}
            className="form-control mb-3"
            placeholder="Position"
          />

          <input
            name="location"
            value={formData.location}
            onChange={handleChange}
            className="form-control mb-3"
            placeholder="Location"
          />

          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
            className="form-select mb-3"
          >
            <option value="pending">Pending</option>
            <option value="interview">Interview</option>
            <option value="rejected">Rejected</option>
          </select>

          <select
            name="jobType"
            value={formData.jobType}
            onChange={handleChange}
            className="form-select mb-3"
          >
            <option value="full-time">Full-time</option>
            <option value="part-time">Part-time</option>
            <option value="remote">Remote</option>
            <option value="internship">Internship</option>
          </select>

          {isEditMode ? (
            <button className="btn btn-primary w-100" type="submit">
              Update Job
            </button>
          ) : (
            <button className="btn btn-primary w-100" type="submit">
              Add Job
            </button>
          )}
        </form>
      </div>
    </div>
  );
}

// const [company, setCompany] = useState("");
// const [position, setPosition] = useState("");
// const [location, setLocation] = useState("");
// const [status, setStatus] = useState("pending");
// const [jobType, setJobType] = useState("full-time");

// const handleSubmit = (e) => {
//   e.preventDefault();
//   const newJob = {
//     company,
//     position,
//     location,
//     status,
//     jobType,
//     createDate: new Date().toISOString(),
//   };
//   dispatch(addJob(newJob));
//   navigate("/all-jobs");
// };
